import Modal from 'react-modal';
import usdc from 'assets/images/coins/usdc.png';

import { Button } from 'components/Button/Button';

import { colors } from 'styles';
import { CaptionText, H3, H4, H5, P1, P2 } from '../../styles/FontStyles';
import { Div, Img, Separator } from '../../styles/Styles';
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getPackagesDetails } from 'services/auth/packages.service';
import Spinner from 'components/Spinner/Spinner';
import { DASHBOARD_PROFILE_ORDERS } from 'routes/routes';
import { WalletComponent } from 'components/Wallet/Wallet';
import { networks, renderPillColor, renderTextColor } from 'helpers/helpers';
import { StatusPill } from 'pages/Orders/Orders.styled';
import { ModalComponent } from 'components/Modal/Modal';
import { CancelPayment } from './CancelPayment';
import { SignUpButton } from 'components/Nav/Nav.styled';

export const PaymentSummary = () => {
  const { id } = useParams();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { loading, packageDetails } = useAppSelector((state) => state.packages);

  useEffect(() => {
    dispatch(getPackagesDetails(Number(id)));
  }, [dispatch]);

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}
      <Div $flex $gap='40px' $width='100%' $columnSM>
        <Div $width='25%' $widthSM='100%'>
          <H3 color={colors.white}>Delivery Details</H3>
          <Separator $m='20px 0' />
          <H3 mb='20' color={colors.white}>
            Shipping address
          </H3>
          <P1 color={colors.white} mb='50'>
            {packageDetails?.shippingInfo?.address}
            <br />
            {packageDetails?.shippingInfo?.postalCode}{' '}
            {packageDetails?.shippingInfo?.city} <br />
            {packageDetails?.shippingInfo?.country}
          </P1>
          <H3 mb='16' color={colors.white}>
            Billing address
          </H3>
          {packageDetails?.isBillingSameAsShipping ? (
            <P1 color={colors.white} mb='50'>
              Same as shipping address
            </P1>
          ) : (
            <P1 color={colors.white} mb='50'>
              {packageDetails?.billingInfo?.address}
              <br />
              {packageDetails?.billingInfo?.postalCode}{' '}
              {packageDetails?.billingInfo?.city} <br />
              {packageDetails?.billingInfo?.country}
            </P1>
          )}
        </Div>
        <Div $width='40%' $widthSM='100%'>
          <Div $box $flex $column>
            <H3 mb='20' color={colors.white}>
              Deposit Crypto
            </H3>
            <P1 mb='10' color={colors.white}>
              Payment Coin
            </P1>

            <Div $flex $gap='12px' $width='100%'>
              <Div $width='100%' $mb='20px'>
                <Div>
                  <Div
                    $box
                    $p='10px 0'
                    $flex
                    $center
                    $gap='4px'
                    $borderRadius='8px'
                  >
                    <img src={usdc} style={{ width: 32 }} />
                    <P2 center color={colors.white}>
                      {packageDetails?.currencyType.toUpperCase()}
                    </P2>
                  </Div>
                </Div>
              </Div>
            </Div>

            <P1 mb='10' color={colors.white}>
              Network
            </P1>

            <Div $flex $gap='12px' $width='100%' $mb='32px'>
              <Div $width='100%'>
                <Div>
                  {networks.map((network, i) => {
                    if (network.networkType === packageDetails?.networkType) {
                      return (
                        <Div
                          key={i}
                          $box
                          $p='10px 0'
                          $flex
                          $center
                          $gap='4px'
                          $borderRadius='8px'
                        >
                          <img src={network.icon} style={{ width: 32 }} />
                          <Div $flex $alignCenter $gap='5px'>
                            <P2 center color={colors.white}>
                              {network.name.toUpperCase()}
                            </P2>
                            <CaptionText mt='2' center color={colors.white}>
                              ({network.network})
                            </CaptionText>
                          </Div>
                        </Div>
                      );
                    }
                  })}
                </Div>
              </Div>
            </Div>

            <P1 mb='10' color={colors.white}>
              Wallet Address
            </P1>
            <WalletComponent value={packageDetails?.walletAddress} />
          </Div>
        </Div>
        <Div $width='35%' $widthSM='100%' $flex $column $between>
          <Div $flex $column>
            <Div $box $flex $column>
              <H3 mb='20' color={colors.white}>
                Order Summary
              </H3>

              <Div $flex $alignCenter $gap='20px' $mb='32px'>
                <Div $box $borderRadius='8px' $p='5px 0'>
                  <Img
                    src={packageDetails?.imageUrl}
                    $height='75px'
                    $heightSM='60px'
                  />
                </Div>
                <H4 color={colors.white}>{packageDetails?.packageName}</H4>
              </Div>

              {/* <InfoValue info='Subtotal' value='$50' />
            <InfoValue info='Shipping' value='$4' /> */}
              <Separator $m='20px 0' />
              <InfoValue
                info='Total (Tax incl.)'
                value={`$${packageDetails?.price}`}
              />

              <Link
                to={DASHBOARD_PROFILE_ORDERS}
                style={{ textDecoration: 'none' }}
              >
                <Div $mt='24px'>
                  <Button $color={colors.blue}>
                    <Div $flex $alignCenter $center $width='100%' $p='0 24px'>
                      <H5>ORDERS</H5>
                    </Div>
                  </Button>
                </Div>
              </Link>
            </Div>

            <Div $box $width='100%' $widthSM='100%' $mt='10px'>
              <Div
                $flex
                $between
                $mb={packageDetails?.status !== 'canceled' ? '15px' : '0px'}
              >
                <P1
                  mb={packageDetails?.status !== 'canceled' ? '10' : '0'}
                  color={colors.white}
                >
                  Payment Status
                </P1>
                <StatusPill
                  $color={renderPillColor(packageDetails?.status)}
                  $textColor={renderTextColor(packageDetails?.status)}
                >
                  {packageDetails?.status}{' '}
                </StatusPill>
              </Div>
              {packageDetails?.status === 'pending' && (
                <Div $flex $justifyCenter>
                  <SignUpButton
                    style={{ width: '200px' }}
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    Cancel payment
                  </SignUpButton>
                </Div>
              )}
            </Div>
          </Div>
        </Div>
      </Div>
      <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title='Cancel Payment'
      >
        <CancelPayment setIsOpen={setIsOpen} id={packageDetails?.id} />
      </ModalComponent>
    </>
  );
};

const InfoValue = ({ info, value }: any) => (
  <Div $flex $between $alignCenter $m='5px 0'>
    <P2 color={colors.white}>{info}</P2>
    <P2 color={colors.white}>{value}</P2>
  </Div>
);
